import { render, staticRenderFns } from "./relatorioChats.vue?vue&type=template&id=07d74c52&scoped=true"
import script from "./relatorioChats.vue?vue&type=script&lang=js"
export * from "./relatorioChats.vue?vue&type=script&lang=js"
import style0 from "./relatorioChats.vue?vue&type=style&index=0&id=07d74c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d74c52",
  null
  
)

export default component.exports